import { SVGProps } from 'react';

function Check(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M6.499 13.921 2.078 9.5a1.973 1.973 0 0 1 2.789-2.79L7.679 9.52 12.945 2.5a1.974 1.974 0 1 1 3.16 2.368L9.473 13.71a1.974 1.974 0 0 1-2.974.211Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </svg>
  );
}

Check.defaultProps = {
  role: 'graphics-document',
};

export default Check;
